import type { SubagentStatusDockModel } from "@t3tools/client-runtime/state/subagent-status-dock";
import { UsersRoundIcon } from "lucide-react";
import { memo } from "react";

import { i18n } from "../../i18n";
import { cn } from "../../lib/utils";

export const SubagentStatusDock = memo(function SubagentStatusDock(props: {
  readonly model: SubagentStatusDockModel;
  readonly onOpen: () => void;
}) {
  const agentsLabel = i18n.t("liveSubagents.dock.agents", { count: props.model.totalCount });
  const runningLabel = i18n.t("liveSubagents.dock.running", {
    count: props.model.runningCount,
  });
  const attentionLabel =
    props.model.attentionCount > 0
      ? i18n.t("liveSubagents.dock.attention", { count: props.model.attentionCount })
      : null;
  const ariaLabel = i18n.t("liveSubagents.dock.open", {
    agents: agentsLabel,
    running: runningLabel,
    attention: attentionLabel
      ? i18n.t("liveSubagents.dock.attentionSuffix", { attention: attentionLabel })
      : "",
  });

  return (
    <div
      className="relative mx-auto mb-2 flex w-full max-w-[400px] justify-center"
      data-subagent-status-dock="true"
    >
      <button
        type="button"
        aria-label={ariaLabel}
        onClick={props.onOpen}
        className={cn(
          "flex min-h-9 w-fit max-w-full cursor-pointer items-center justify-center gap-2 rounded-full border bg-card px-3.5 py-1.5 text-sm font-medium text-muted-foreground shadow-xs tabular-nums hover:border-border hover:text-foreground focus-visible:outline-2 focus-visible:outline-ring focus-visible:outline-offset-2",
          props.model.tone === "attention" ? "border-amber-500/35" : "border-border/60",
        )}
      >
        <UsersRoundIcon aria-hidden="true" className="size-3.5 shrink-0" strokeWidth={2} />
        <span className="truncate">{agentsLabel}</span>
        <span aria-hidden="true" className="text-muted-foreground/45">
          ·
        </span>
        <span className="shrink-0">{runningLabel}</span>
        {attentionLabel ? (
          <>
            <span aria-hidden="true" className="text-muted-foreground/45">
              ·
            </span>
            <span className="shrink-0 text-amber-600 dark:text-amber-300">{attentionLabel}</span>
          </>
        ) : null}
      </button>
    </div>
  );
});
